module.exports = __webpack_public_path__ + "static/media/room-image4.def14a20.png";